// extracted by mini-css-extract-plugin
export default {"container":"bN2FH3","glitch":"IgbEpz","text":"C6EyP4","without-scope":"cojUva","withoutScope":"cojUva","block":"JujkFJ"};